<script>
import Popin from "@/components/molecules/popin";
import CmsMenu from "@/components/organisms/cms/cms-menu/mobile";
import ButtonIcon from "@/components/molecules/button-icon";

export default {
  name: "CmsMenuPopin",
  components: {
    Popin,
    CmsMenu,
    ButtonIcon
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    hasLocationCora: {
      type: Boolean,
      required: false,
      default: false
    },
    webAlias: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    routePath() {
      return useRoute().fullPath;
    }
  },
  watch: {
    routePath() {
      if (this.$refs.popin && this.$refs.popin.hide) {
        this.$refs.popin.hide();
      }
    }
  },
  methods: {
    show() {
      this.$refs.popin.show();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    page
    aria-label="menu"
  >
    <div>
      <ButtonIcon
        icon-name="cross"
        @click="$refs.popin.hide()"
      >
        Fermer
      </ButtonIcon>
    </div>
    <CmsMenu
      :has-location-cora="hasLocationCora"
      :web-alias="webAlias"
      :menu="menu"
    />
    <ButtonIcon
      icon-name="cross"
      class="u-mb-sm"
      @click="$refs.popin.hide()"
    >
      Fermer
    </ButtonIcon>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
